import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-ranking-tecnicos',
  templateUrl: './ranking-tecnicos.component.html',
  styleUrls: ['./ranking-tecnicos.component.css']
})
export class RankingTecnicosComponent implements OnInit {

  constructor(private service: UserService, private toast: ToastrService) { }

  selectedProvincia = "";
  searchText = "";
  selectedLocalidad = "";

  provincias = new Set();
  localidades = [];
  tecnicos = [];
  asignaciones = [];

  pipe = new DatePipe('en-US');

  zonas = [];

  ngOnInit() {
    this.service.getZones().subscribe(d=> {
      this.zonas = d ;
    });
    
    
    this.service.getTecnicos().subscribe(d=>{
      this.tecnicos = d;
      this.tecnicos.sort( (a,b)=> { return a.puntos_mes >  b.puntos_mes ? -1:1})
      this.service.getAsignaciones("").subscribe(d2=>{
        this.asignaciones = d2.asignaciones;

        this.asignaciones.forEach(x=> {  x.date = this.pipe.transform(new Date(x.fecha), "dd/MM/yyyy") })
        this.tecnicos.forEach(t=>  { 
          t.tickets_finalizados = this.asignaciones.filter(x=> x.type=="T" && x.tecnico == t._id).length;
          t.data = (t.nombre + " " + t.apellido + " " + t.legajo).toLowerCase(); } 
        );
        


        this.tecnicos.forEach(t=> {
          t.data = (t.nombre + " " + t.apellido + " " + t.legajo).toLowerCase();
  
          let provincias = new Set();
          t.zonas.forEach(z=> provincias.add(z.provincia));
          t.provincias = provincias;
  
  
          t.zonas.forEach(z=>{this.provincias.add(z.provincia)});
          
        });
        this.filter();
      }, er=>{
        this.toast.error("ERROR");
      })
    }, er=>{
      this.toast.error("ERROR");
    })
  }

  sortState ={};
  sort(column){
    this.sortState[column] = !this.sortState[column];
    this.filter();
    this.tecnicos = this.tecnicos.sort( (a,b) =>{
      return  (a[column] > b[column] )? (this.sortState[column]?1:-1) :(this.sortState[column]?-1:1);
    })
    this.filter();
    
  }

  
  filteredTecnicos = [];
  filter(){
    let ret = this.tecnicos;
    if(this.searchText.length>0) ret = this.tecnicos.filter(x =>  x.data.indexOf(this.searchText.toLowerCase())>=0);
    if(this.selectedProvincia!=""){
      ret = ret.filter( x => Array.from(x.provincias).indexOf(this.selectedProvincia)>=0 );
      if(this.selectedLocalidad!="") ret = ret.filter( x => x.zonas.filter( z=> z.provincia == this.selectedProvincia).map(z=>{ return z.localidad } ).indexOf(this.selectedLocalidad)>=0 );
    } 


    this.filteredTecnicos = ret;
  }



  getLocaliadades(){
    this.selectedLocalidad = "";
    this.localidades = this.zonas.filter( x=> x.provincia == this.selectedProvincia).map(x=>{ return x.localidad }); 
    this.filter();
    this.getChartData();
    // if(this.localidades.length>0){
    //   let ret = [];
    //   ret = this.tecnicos.filter( x => this.searchText.length==0 ||  x.data.indexOf(this.searchText.toLowerCase())>=0);
    //   if(this.selectedProvincia!="") ret = ret.filter( x => x.provincias.indexOf(this.selectedProvincia)>=0 );
    //   if(this.selectedLocalidad!="") ret = ret.filter( x => x.zonas.filter( z=> z.provincia == this.selectedProvincia).map(z=>{ return z.localidad } ).indexOf(this.selectedLocalidad)>=0 );
    //   this.getChartData(ret);
    // }

  }


  chartData;
  chartLabels = [];
  getChartData(){
    console.log("Getting chart data");
    this.chartLabels = [];
    if(this.filteredTecnicos.length>10) return this.chartData = null;
    this.chartOptions.title.text =  "Acumulado de puntos ult 30 días (" + this.selectedProvincia + ")";
    let today = new Date();
    this.chartData = [];
    
    let first = true;
    
    this.filteredTecnicos.forEach(tecnico => {
      let asignaciones = this.asignaciones.filter(x=>  x.tecnico == tecnico._id);
      let count = 0;
      let data = [];
      for(let i = 30; i>=0; i--){
        let date = new Date().setDate( today.getDate()-i);
        let label = this.pipe.transform(  date, "dd/MM/yyyy");
         let sum = asignaciones.filter(x=> x.date == label).reduce((sum, current) => sum + current.cantidad, 0);
          count = count + sum;
          data.push(count)
          if(first) this.chartLabels.push(label.substr(0,5));
      }
      first = false;
      this.chartData.push( { data: data, label: tecnico.nombre + ' ' + tecnico.apellido });
    });
    console.log(this.chartData);

  }

  chartOptions = {
    title: {
      text:  "Acumulado de puntos ult 30 días (" + this.selectedProvincia + ")",
      display: true,
      fontColor: 'white'
    },
    responsive: true,
    legend : {
      labels : {
        fontColor : '#ffffff'  
      }
    },
    scales: {
      xAxes: [{
        stacked: true,
        ticks: {
          fontColor: 'white',  // x axe labels (can be hexadecimal too)
        },
        gridLines: {
          color: '#5f5e5e'  // grid line color (can be removed or changed)
        }
      }],
      yAxes: [{
        stacked: false,
        ticks: {
          fontColor: 'white',  // y axes numbers color (can be hexadecimal too)
          callback: function(value) {if (value % 1 === 0) {return value;}},

        },
        gridLines: {
          color: '#5f5e5e'  // grid line color (can be removed or changed)
        },
        scaleLabel: {
          display: true,
          labelString: 'Puntos',
          fontColor: 'white',  // y axe label color (can be hexadecimal too)
        }
      }]
    },
  };


}
